export default {
      id: "icon-youtube-usage",
      viewBox: "0 0 36 36",
      url: __webpack_public_path__ + "img/icons.10719bc6.svg#icon-youtube",
      toString: function () {
        return this.url;
      }
    }